import { Component } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  constructor(private oauthService: OAuthService, private router: Router) { }

  public logout() {
    this.oauthService.logOut();
    this.router.navigate(['/']);
  }
}
